import ScrollMagic from 'scrollmagic'

export default class PhoneParalax {
  constructor() {
    this._container = document.querySelector('.phones-paralax')

    if (this._container) {
      this._controller = new ScrollMagic.Controller()
      this._rows = this._container.querySelectorAll('.phones-paralax__row')
      this.scrollHandler()
    }
  }

  scrollHandler() {
    new ScrollMagic.Scene({
      triggerElement: this._container,
      duration: '100%'
    })
      .addTo(this._controller)
      .on('progress', e => {
        const progress = Math.round(e.progress * 300)
        this._rows[0].style.transform = `translateY(${progress}px)`
        this._rows[1].style.transform = `translateY(${-progress}px)`
      })
  }
}

